import React, { Component } from 'react'
import { connect } from 'shalala';
import { Route } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import { useStore } from '../../store';
import TimbradoMasivoUpload from './TimbradoMasivoUpload';
import TimbradoMasivoList from './archivos/list/TimbradoMasivoList';
import SearchByDatesAndKeyword from '../../shared/SearchByDatesAndKeyword';
import TimbradoMasivoListActions from './archivos/list/components/TimbradoMasivoListActions';
import TimbradoMasivoFilterByType from './archivos/list/components/TimbradoMasivoFilterByType';
import TimbradoMasivoListItemActions from './archivos/list/components/TimbradoMasivoListItemActions';

class TimbradoMasivoFiles extends Component {

  state = {
    selectedRowKeys: [],
    selectedRows: []
  }

  componentDidMount() {
    window.setAppTitle('Facturación Masiva');
  }

  handleOnRowSelectionChange = ({selectedRowKeys, selectedRows}) => {
    this.setState({
      selectedRowKeys,
      selectedRows
    });
  }

  handleOnRowClick = (data) => {
    this.props.history.replace({
      pathname: `/modulos/timbrado-masivo/${data.id}/info`,
      state: {
        data: {...data}
      }
    });
  }

  handleOnDateChange = (values) => {
    this.props.paginate(values);
  }

  handleOnKeywordChange = (search) => {
    this.props.paginate({ search });
  }

  render() {
    const { selectedRowKeys, selectedRows } = this.state;
    const { from, to, search } = this.props.pagination;

    return (
      <>
        <Row>
          <Col sm="auto" md="7" className="mb-2">
            <div>
              { selectedRowKeys.length > 0 && (
                <div className="mr-3 d-inline-flex pb-2">
                  <TimbradoMasivoListItemActions
                    selectedRowKeys={ selectedRowKeys }
                    selectedRows={ selectedRows }
                    alignRight={ false }
                  />
                </div>
              )}

              { selectedRowKeys.length === 0 && (
                <SearchByDatesAndKeyword
                  from={ from }
                  to={ to }
                  search={ search }
                  onDateChange={ this.handleOnDateChange }
                  onKeywordChange={ this.handleOnKeywordChange }
                />
              )}
            </div>
          </Col>

          <Col sm="auto" md="5" className="text-right pb-2">
            <TimbradoMasivoListActions />
          </Col>

        </Row>

        <Row>
          <Col>
            <TimbradoMasivoFilterByType />
          </Col>
        </Row>

        { Guardian.allows('facturacion.masiva.listar.archivos') && (
          <TimbradoMasivoList
            onRowClick={ this.handleOnRowClick }
            selectedRowKeys={ selectedRowKeys }
            selectedRows={ selectedRows }
            onRowSelectionChange={ this.handleOnRowSelectionChange }
          />
        )}

        <Route path="/modulos/timbrado-masivo/archivos/upload" component={ TimbradoMasivoUpload } />
      </>
    )
  }
}

const mapState = (store) => {
  return store.modulo.timbrado_masivo.archivos
}

const mapActions = (actions) => {
  return actions.modulo.timbrado_masivo.archivos;
}

export default connect(useStore, mapState, mapActions)(TimbradoMasivoFiles)